var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100 d-flex flex-column" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-start align-items-center" },
        [
          _c(
            "a",
            {
              staticClass:
                "home-link mr-auto font-weight-light link-white px-24 py-16",
              attrs: { href: _vm.route("nl.home") }
            },
            [_c("strong", [_vm._v("InspireYourTribe")]), _vm._v(".be")]
          ),
          _vm._v(" "),
          _c("mobile-search"),
          _vm._v(" "),
          _c("hamburger-button")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "slide-x-left-transition",
        { attrs: { duration: { enter: 300, leave: 0 }, mode: "out-in" } },
        [
          !_vm.extraOpen
            ? _c(
                "div",
                {
                  key: "menu",
                  staticClass:
                    "d-flex flex-column flex-grow-1 justify-content-between"
                },
                [
                  _c("div", { staticClass: "container my-auto" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 d-flex flex-column justify-content-center align-items-start"
                        },
                        _vm._l(_vm.routes, function(route) {
                          return _c(
                            "a",
                            {
                              key: route.pagina.title,
                              staticClass: "mb-32 link-white lh-34",
                              class: _vm.currentlyViewing(route.pagina.url)
                                ? "font-weight-normal"
                                : "font-weight-light",
                              attrs: { href: route.pagina.url }
                            },
                            [_vm._v(_vm._s(route.pagina.title))]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "row mb-24" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "p",
                          { staticClass: "text-white font-weight-light mb-16" },
                          [
                            _vm._v(
                              "\n                            Powered by\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.tothepointevents.be/",
                              target: "_blank",
                              rel: "noopener"
                            }
                          },
                          [
                            _c("h3", [
                              _c("img", {
                                staticClass: "logo",
                                attrs: {
                                  src: "/svg/to-the-point-events-logo.svg",
                                  alt: "To The Point Events."
                                }
                              }),
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("To The Point Events.")
                              ])
                            ])
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.extraOpen
            ? _c(
                "div",
                {
                  key: "extra",
                  staticClass: "container my-auto overflow-auto extra-menu"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 d-flex flex-column justify-content-center align-items-start"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-inline text-accent small back",
                            on: {
                              click: function($event) {
                                _vm.extraOpen = false
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-arrow-left mr-8 mb-32"
                            }),
                            _c("span", [_vm._v("Terug")])
                          ]
                        ),
                        _vm._v(" "),
                        _c("menu-extra-dropdown", {
                          staticClass: "link-white lh-34 mb-32",
                          attrs: {
                            label: _vm.extraLabel,
                            "landing-pages": _vm.landingPages,
                            open: _vm.extraOpen
                          },
                          on: {
                            change: function(value) {
                              return (_vm.extraOpen = value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }